import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import { useWallet } from '../context/WalletContext';
import { useUserData } from '../hooks/useUserData';
import StatsOverview from '../components/dashboard/StatsOverview';
import IncomeBreakdown from '../components/dashboard/IncomeBreakdown';
import ReferralLink from '../components/dashboard/ReferralLink';
import ActivityFeed from '../components/dashboard/ActivityFeed';
import PendingClaimsCard from '../components/dashboard/PendingClaimsCard';
import WalletModal from '../components/wallet/WalletModal';

const Dashboard = () => {
  const { account } = useWallet();
  const [refreshKey] = useState(0);
  const user = useUserData(refreshKey);
  const [open, setOpen] = useState(false);

  if (!account) {
    return (
      <Layout dashboard>
        <div style={{ padding: '40px 20px', textAlign: 'center' }}>
          <h2 className="text-yellow">Connect Wallet</h2>
          <p className="text-muted" style={{ marginTop: 8 }}>Connect your wallet to view your dashboard.</p>
          <button className="btn btn-primary btn-lg" style={{ marginTop: 18 }} onClick={() => setOpen(true)}>Connect Wallet</button>
          <WalletModal open={open} onClose={() => setOpen(false)} />
        </div>
      </Layout>
    );
  }

  if (user.loaded && !user.registered) return <Navigate to="/register" replace />;

  return (
    <Layout dashboard>
      <div className="page-header">
        <div className="page-title">Dashboard</div>
        <div className="page-subtitle">Welcome back, #{user.userId || '—'}</div>
      </div>

      <StatsOverview user={user} />

      <div className="section" />

      <div className="grid grid-2">
        <PendingClaimsCard user={user} />
        <ReferralLink userId={user.userId} />
      </div>

      <div className="section" style={{ marginTop: 24 }}>
        <div className="section-title">Income Breakdown</div>
        <IncomeBreakdown income={user.income} />
      </div>

      <div className="section">
        <div className="section-title">Recent Activity</div>
        <ActivityFeed activities={user.activities} />
      </div>
    </Layout>
  );
};

export default Dashboard;
